import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'accomptence'
const baseUrl = process.env.REACT_APP_SERVICE_ASSESMENT_URL
const appCode = process.env.REACT_APP_SERVICE_ASSESMENT_APPCODE
const outputType = 'json'

//Manajerial
export const masterCategories = 'Master/Accategories/list_manajerial/'
export const acmanajerialCreate = 'accompetence/manajerial/create/'
export const acmanajerialList = 'accompetence/manajerial/list/'
export const acmanajerialDetail = 'accompetence/manajerial/detail/'
export const acmanajerialLevel = 'accompetence/manajerial/detail_level/'
export const acmanajerialUpdate = 'accompetence/manajerial/update/'
export const acmanajerialInactive = 'accompetence/manajerial/inactive/'
export const acmanajerialActive = 'accompetence/manajerial/active/'
//Teknis
export const masterCategoriestek = 'Master/Accategories/list_teknis/'
export const acteknisCreate = 'accompetence/teknis/create/'
export const acteknisList = 'accompetence/teknis/list/'
export const acteknisDetail = 'accompetence/teknis/detail/'
export const acteknisLevel = 'accompetence/teknis/detail_level/'
export const acteknisUpdate = 'accompetence/teknis/update/'
export const acteknisInactive = 'accompetence/teknis/inactive/'
export const acteknisActive = 'accompetence/teknis/active/'
//Sosio Kultural
export const masterCategoriessos = 'Master/Accategories/list_sosiokultural/'
export const acsosiokulturalCreate = 'accompetence/sosiokultural/create/'
export const acsosiokulturalList = 'accompetence/sosiokultural/list/'
export const acsosiokulturalDetail = 'accompetence/sosiokultural/detail/'
export const acsosiokulturalLevel = 'accompetence/sosiokultural/detail_level/'
export const acsosiokulturalUpdate = 'accompetence/sosiokultural/update/'
export const acsosiokulturalInactive = 'accompetence/sosiokultural/inactive/'
export const acsosiokulturalActive = 'accompetence/sosiokultural/active/'
//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}